import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { ROUTINE_HANDOFF_CHANNEL } from "./routine_handoff_controller"

// Takes the redrawn sections a native modal's save hands over
// (routine_handoff_controller.js) and confirms, so the modal can close without
// refreshing this page. Only the page on screen behind the modal takes them;
// one in another tab stays as it is and catches up when it shows again.
export default class extends Controller {
  static values = { routineId: String }

  connect() {
    if (typeof BroadcastChannel === "undefined") return

    this.channel = new BroadcastChannel(ROUTINE_HANDOFF_CHANNEL)
    this.channel.onmessage = (event) => this.receive(event.data)
  }

  disconnect() {
    this.channel?.close()
  }

  receive({ type, id, routineId, streams } = {}) {
    if (type !== "update" || routineId !== this.routineIdValue) return
    if (document.visibilityState !== "visible" || document.documentElement.hasAttribute("data-turbo-preview")) return

    Turbo.renderStreamMessage(streams)
    this.channel.postMessage({ type: "applied", id })
    window.dispatchEvent(new CustomEvent("routine-handoff:applied"))
  }
}
